module.exports = __webpack_public_path__ + "static/media/armenia.5e23ed56.png";